import _ from "lodash";

export const hasAuthorizedSession = (user) => {
  if (!user) return false;
  const userInfo = _.get(user, "userInfo", null);
  if (!userInfo) return false;
  return Boolean(_.get(userInfo, "planStatus", null) && _.get(userInfo, "userStatus", null));
};
